import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { typography } from 'src/config/typography';
import { colors } from 'src/config/colors';
import { media } from 'src/config/breakpoints';
import { ContactDetails } from 'src/public/components/contact/ContactDetails';
import contactImg from 'src/assets/images/contact-img-final.png';
import Image from 'next/image';

const ContactImage = styled.div`
  display: none;

  ${media.w.min.px768(css`
    display: revert;
    max-width: 25.5rem;
  `)};
`;

const Container = styled.div`
  ${media.w.max.px768(css`
    margin: 0 auto;
    max-width: 25.625rem;
  `)};

  ${media.w.min.px576(css`
    padding: 0 1.188rem;
  `)};

  ${media.w.min.px768(css`
    padding: 0 1.188rem 4rem;
  `)};
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5rem;

  ${media.w.min.px768(css`
    flex-direction: row;
  `)};
`;

const Title = styled.h1`
  color: ${colors.red};
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1.5rem;
  font-weight: 500;
  grid-area: title;
  line-height: 1.875rem;
  margin: 1.25rem 0 0 0;

  ${media.w.min.px768(css`
    font-size: 2.3125rem;
    line-height: 2.875rem;
    margin-top: 0.625rem;
  `)};

  ${media.w.min.px992(css`
    margin-top: 3.25rem;
  `)};
`;

export const ContactPageContent: FC = () => {
  return (
    <Container>
      <Title>Skontaktuj się z nami</Title>
      <Content>
        <ContactDetails />
        <ContactImage>
          <Image src={contactImg} />
        </ContactImage>
      </Content>
    </Container>
  );
};
